import React from 'react';
import Kendra from 'aws-sdk/clients/kendra';

import { isNullOrUndefined } from '../../facets/utils';
import { Box } from '@cloudscape-design/components';

interface HighlightedTextProps {
    text: string | undefined;
    highlight: Kendra.Highlight;
}

export const HighlightedText = ({ text, highlight }: HighlightedTextProps) => {
    return (
        <Box
            variant="span"
            color={
                !isNullOrUndefined(highlight.TopAnswer) && highlight.TopAnswer
                    ? 'text-status-info'
                    : 'inherit'
            }
            fontSize="body-m"
            fontWeight="bold"
        >
            {!isNullOrUndefined(text) &&
                text?.substring(highlight.BeginOffset, highlight.EndOffset)}
        </Box>
    );
};
